
export const ROLE_PERMISSIONS: Record<string, any> = {
  'Model Runner': {
    menus: {
      todos: true,
      bpAllSubmissions: true,
      dashboardManagement: true,
    },
    tabs: {
      workbenchViewquickSummary: false,
      workbenchViewdetails: false,
      workbenchViewmodelPricing: true,
      workbenchViewrateChangeCalculator: false,
      workbenchViewQuote: false,
      workbenchViewcaseSummary: false
    },
    pages: {
      todos: true,
      bpAllSubmissions: true,
      dashboardManagement: true,
    },
    actions: {
      todosPriorities: true,
      todosWorkbench: true,
    }
  }

};
